import React from "react";
import NotFoundView from "./NotFoundView";

export function NotFoundContainer() {
  return <NotFoundView />;
}
